import { JobPosting } from "@nimble/candidate-api/types";
import Link from "next/link";
import { ReactNode } from "react";

import JobPostingBullets from "@/components/shared/jobs/job-posting-bullets";
import { jobHeaderTestIds } from "@/lib/data-test-ids/jobs.data-test-ids";

interface JobDetailsHeaderContentProps {
  jobPosting: JobPosting;
  titleHref: string;
  eyebrow?: ReactNode;
  children?: ReactNode;
}

export default function JobDetailsHeaderContent({
  jobPosting,
  titleHref,
  eyebrow,
  children,
}: JobDetailsHeaderContentProps) {
  const title = jobPosting.title;
  const jobId = jobPosting.uuid;

  return (
    <div
      className="flex flex-col pr-0 gap-4 flex-1 min-w-0 sm:pr-0 "
      data-testid={`${jobHeaderTestIds.JOB_HEADER}-${jobId}`}
    >
      {eyebrow}
      <Link href={titleHref}>
        <h2
          className="text-xl sm:text-2xl font-bold text-foreground leading-tight break-words hover:text-primary"
          style={{ wordBreak: "break-word", overflowWrap: "anywhere" }}
          data-testid={`${jobHeaderTestIds.JOB_TITLE}-${jobId}`}
        >
          {title}
        </h2>
      </Link>
      <div className="flex flex-col gap-3">
        <JobPostingBullets job={jobPosting} />
      </div>
      {children}
    </div>
  );
}
